import { FC } from 'react';
import classNames from 'classnames';

import styles from './Loader.module.css';

interface SpinnerProps {
	className?: string;
	size?: 'small' | 'big';
}

export const Loader: FC<SpinnerProps> = ({ className, size = `big` }) => (
	<div className={classNames(styles.loader__container, className)}>
		<svg
			viewBox='0 0 64 64'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={classNames(styles.loader__svg, styles[`loader__svg--${size}`])}
		>
			<path
				d='M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM9.33308 32C9.33308 44.5186 19.4814 54.6669 32 54.6669C44.5186 54.6669 54.6669 44.5186 54.6669 32C54.6669 19.4814 44.5186 9.33308 32 9.33308C19.4814 9.33308 9.33308 19.4814 9.33308 32Z'
				className={styles[`loader__path-secondary`]}
			/>
			<path
				d='M32 4.66654C32 2.08928 29.8998 -0.0348697 27.3499 0.339655C23.0273 0.974554 18.8634 2.49057 15.1234 4.81211C10.0563 7.9575 5.96893 12.4564 3.32261 17.8012C0.676282 23.1459 -0.423723 29.1239 0.1467 35.0606C0.567716 39.4423 1.88634 43.6729 4.00194 47.4955C5.24993 49.7504 8.21246 50.133 10.2621 48.5705C12.3118 47.0081 12.6553 44.092 11.5449 41.7662C10.4089 39.3867 9.69147 36.8163 9.437 34.168C9.03294 29.9627 9.81212 25.7283 11.6866 21.9424C13.5611 18.1564 16.4563 14.9697 20.0456 12.7417C22.3061 11.3385 24.7852 10.3508 27.3663 9.81176C29.8891 9.28489 32 7.2438 32 4.66654Z'
				className={styles[`loader__path-primary`]}
			/>
		</svg>
	</div>
);
